/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components'

const SearchLayoutStyled = styled.div<any>`
  ${({ isMobile, emptyProducts }) =>
    !isMobile &&
    css`
      display: grid;
      width: 100%;
      grid-template-columns: ${!emptyProducts ? '320px 1fr' : '1fr'};
    `}
  .search-filter {
    width: 100%;
  }
  .filters-container {
    display: flex;
    flex-direction: column;
    margin-top: var(--spacing-margin-small);
    .filterSort-content {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
    }
    .filtersApplied-content {
      max-width: 1000px;
    }
    .select-sort-filter-content {
      width: 212px;
    }
  }

  .search-filter-applied {
    margin-top: 16px;
  }
  .filter-applied-loading-container {
    margin-top: 20px;
  }
  .products-container {
    margin-top: 20px;
  }
`

export default SearchLayoutStyled
